import { Pipe, PipeTransform } from '@angular/core';
import memoize from '@github/memoize/decorator';
import { FinancialUtils } from '../utils/financial';

@Pipe({ name: 'fromPercents' })
export class FromPercentsPipe implements PipeTransform {
  @memoize()
  public transform(
    value?: number | null,
    ...args: (number | undefined | null)[]
  ): number {
    return FinancialUtils.fromPercents(args[0] || 0, value || 0);
  }
}
